export type { BannerPhotoProps } from "./banner-photo";
export { BannerPhoto } from "./banner-photo";
